// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/@nuxt/postcss8/node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".base-layout{position:relative;display:grid;grid-template-rows:auto auto minmax(0,1fr);grid-template-columns:auto minmax(0,1fr);min-height:100vh}.base-layout__container{position:relative;grid-column-start:2;grid-row-start:3;display:flex;flex-direction:column;justify-content:space-between}@media (min-width:1024px){.base-layout__container{margin-left:5.5rem}}@media (min-width:1280px){.base-layout__container{margin-left:0}}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
